export default __webpack_public_path__ + "static/media/ban-desktop-image-11.c14ed4d8.jpg";